module.exports = "/assets/bc3c878cf547d5d0d44d4081984946a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/8J.png
// module id = 1137
// module chunks = 0